module.exports = __webpack_public_path__ + "img/tell_screenshot.22002e94.jpg";